<template>
    <section v-if="hasPermissions(['Assignment-Service-Request Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="row bar__container">
            <div class="col-md-6 py-0 mb-3 mb-md-0">
                <div class="input-field my-0" v-if="associate_requests.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="col-4 col-md-2 py-0">
                <ul class="nav nav-tabs" v-if="associate_requests.length">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#listation"> <i class="fa fa-list"/> </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#cards-listation">  <i class="fa fa-th-large"/> </a>
                    </li>
                </ul>
            </div>
            <div class="col-8 col-md-4 py-0" v-if="hasPermissions(['Assignment-Service-Request Write'])">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="associate_requests.length">
            <div class="tab-pane fade" id="cards-listation">
                <div class="row mb-0">
                    <div class="col-sm-6 col-lg-3" v-for="(value, i) in associate_requests" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a href="#" @click="modal_update(i)" class="textTitleCard">
                                                    {{ `${i+1}. ${value.comment}` }}
                                                </a>
                                            </div>
                                            <div class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-12">
                                            <ul class="list">
                                                <li v-html="`${value.service_request}`" class="list__item"></li>
                                                <li v-html="`${value.associate}`" class="list__item"></li>
                                                <li v-html="`${value.date}`" class="list__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-action">
                                    <a :href="'#'+value.id" class="card-action__link">
                                        View more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <v-data-table
                                v-model="table_selection"
                                :headers="table_headers"
                                :items="associate_requests"
                                :search="search"
                                :single-select="single_select"
                                item-key="id"
                                show-select
                                class="elevation-1"
                            >
                                <template v-slot:[`item.paid`]="{item}">
                                    {{ format_boolean(item.paid) }}
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api_child, $event)"
        />

        <FormModal 
            :title="'New A. Service Request'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api_child"
            :parent_id="uncrypted_parent_id"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'A. Service Request Update'"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import DeletionModal    from    '@/components/DeletionModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'AssociateServiceRequest',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        UnauthorizedComponent,
    },

    data(){
        return{
            notyf,
            parent:                 {},
            parent_id:              this.$route.params.id,
            uncrypted_parent_id:    '',
            title_page:             'Associate Service Request',
            rest_api:               `service_requests/${this.$route.params.id}`,
            rest_api_child:         `associate_service_requests`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            boolean_options:        FormResources.boolean_options,
            status_options:         FormResources.status_options,
            exc_options:            FormResources.exc_options,
            simbol_options:         FormResources.simbol_options,
            add_btn:                'Add A. Service Request',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            associate_requests:     [],
            array_options:          {},
        }
    },

    methods:{
        
        unshift_object(new_object)
        {
            this.associate_requests.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.associate_requests.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.associate_requests[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.associate_requests[index]
            window.$('#static-update').modal('show')
        },
        
        fill_data(data)
        {
            this.parent               =  data.service_request
            this.uncrypted_parent_id  =  data.parent_id
            this.associate_requests   =  data.associate_service_request
            this.array_options = {
                associate_id:   data.associates,
            }
            this.breadcrumb.push({
                name:   `${this.parent.description}`,
                href:   '#',
                arrow:  "",
            })
        },

        trashing(index)
        {
            this.associate_requests.splice(index, 1)
        },

    },

    async mounted(){
        if(this.hasPermissions(['Assignment-Service-Request Read']))
        {
            await this.api_request()
        }
    }
}
</script>